import React from "react";
import { type DropdownWithoutOptionsProps } from "../models";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";

const ProductTypesDropdown = (props: DropdownWithoutOptionsProps<server.dto.ProductType>) => {
  return <BaseReactSelectDropdown
    excludeKeys={[]}
    options={serverReference.productTypes}
    getLabel={p => p.text}
    getValue={(t) => t.value}
    value={props.value}
    onChange={props.onChange}
    config={props.config}
  />;
};

export default ProductTypesDropdown;